import { Vec2 } from "../../../models/SyntheticMap";
import { BaseVisual } from "../../../visuals/BaseVisual";
import { Typography } from "@mui/material";
import { useEffect } from "react";

export interface ObjectLabelData {
  visual: BaseVisual;
  screenPos: Vec2;
}

export function ObjectLabel({ data }: { data: ObjectLabelData }) {
  const { visual, screenPos } = data;
  useEffect(() => {
  }, [visual, screenPos]);
  return (
    <div
      style={{
        position: 'absolute',
        left: `${screenPos.x}px`,
        top: `${screenPos.y}px`,
        color: 'white',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '2px 4px',
        pointerEvents: 'none',
      }}
    >
      <Typography variant="caption" style={{ fontSize: '0.8rem' }}>
        {visual.id}
      </Typography>
    </div>
  );
}